import { render, staticRenderFns } from "./dashboardLynparza.vue?vue&type=template&id=5d8972e3&"
import script from "./dashboardLynparza.vue?vue&type=script&lang=js&"
export * from "./dashboardLynparza.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports